var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("stepheader", { attrs: { step: _vm.step } }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "body current",
          attrs: {
            id: "wizard2-p-0",
            role: "tabpanel",
            "aria-labelledby": "wizard2-h-0",
            "aria-hidden": "false",
          },
        },
        [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.ticket.codiceSblocco,
                    expression: "ticket.codiceSblocco",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text" },
                domProps: { value: _vm.ticket.codiceSblocco },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.ticket, "codiceSblocco", $event.target.value)
                  },
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("buttons", {
            attrs: { buttons: _vm.step.buttons },
            on: { action: _vm.fireaction },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "label",
      { staticClass: "form-label", attrs: { for: "codicesblocco" } },
      [
        _vm._v("Codice Sblocco: "),
        _c("span", { staticClass: "tx-danger" }, [_vm._v("*")]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }